export default "__VITE_ASSET__KiKzeP5U__"